import * as RUBYPLAY_ERRORS_MESSAGES from '@gongxigames/framework/slot/configs/messages';
import {IEventManagerWithAsync} from '@gongxigames/framework/core';
import {GlobalEventsMapForBackwardCompatibility} from '@gongxigames/framework/slot/events';

export class ErrorsPopupPage {
    constructor(eventManager: IEventManagerWithAsync<GlobalEventsMapForBackwardCompatibility>) {
        const rubyPlayErrorsContainer = document.getElementById('rubyplay-errors-cont')!;

        const closeBtn = document.getElementById('closeBtnError')!;

        closeBtn.style.margin = '4px';
        closeBtn.style.fontSize = '10px';
        closeBtn.onclick = () => {
            eventManager.emit('General.Message.CLOSE');
        };

        for (const [name, value] of Object.entries(RUBYPLAY_ERRORS_MESSAGES)) {
            const button = document.createElement('div');

            button.onclick = () => {
                eventManager.emit('General.Message.CLOSE');
                eventManager.emit('General.Message.SHOW', value );
            };
            button.innerHTML = name;
            button.style.margin = '4px';
            button.style.fontSize = '10px';

            rubyPlayErrorsContainer.appendChild(button);
        }
    }
}
